import './reclamo.css'
export default function StroReclamo({ stro, theme }) {
    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    }
    return (
        <div className={theme === 1 ? 'contenedorStroReclamo' : 'contenedorStroReclamoDark'}>
            <h4 className={theme === 1 ? '' : 'text-white'}>Denuncia Administrativa</h4>
            <div className='d-flex gap-3 mt-5'>
                <strong className={theme === 1 ? 'w-25' : 'w-25 text-white'}>Fecha Stro</strong>
                <div className={theme === 1 ? 'inputReclamo' : 'inputReclamoDark'}>{formatDate(stro?.fechaStro)}</div>
            </div>
            <div className='d-flex gap-3 mt-3'>
                <strong className={theme === 1 ? 'w-25' : 'w-25 text-white'}>Poliza</strong>
                <div className={theme === 1 ? 'inputReclamo' : 'inputReclamoDark'}>{stro.pza}</div>
            </div>
            <div className='d-flex gap-3 mt-3'>
                <strong className={theme === 1 ? 'w-25' : 'w-25 text-white'}>Calle del stro</strong>
                <div className={theme === 1 ? 'inputReclamo' : 'inputReclamoDark'}>{stro.direccionStroCalle}</div>
            </div>
            <div className='d-flex gap-3 mt-3'>
                <strong className={theme === 1 ? 'w-25' : 'w-25 text-white'}>Localidad</strong>
                <div className={theme === 1 ? 'inputReclamo' : 'inputReclamoDark'}>{stro.direccionStroLocalidad}</div>
            </div>
            <div className='d-flex gap-3 mt-3'>
                <strong className={theme === 1 ? 'w-25' : 'w-25 text-white'}>Relato</strong>
                <div className={theme === 1 ? 'inputReclamo3' : 'inputReclamo3Dark'}>{stro.detallesStro}</div>
            </div>
            <div className='d-flex gap-3 mt-3'>
                <strong className={theme === 1 ? 'w-25' : 'w-25 text-white'}>Daños</strong>
                <div className={theme === 1 ? 'inputReclamo3' : 'inputReclamo3Dark'}>{stro.detallesDaniosAseg}</div>
            </div>
        </div>
    )
}
